import { show, startTour, trackEvent } from '@intercom/messenger-js-sdk';
import store from '@/store';
import { trackSecondaryEvent } from '@/lib/rudderstack-helper';

const CHECKLISTS_WHO_SEES_WHAT_ID = 44665563;
const CHECKLISTS_DISCOVER_CORE_CAPABILITIES_ID = 44686407;

export function openChecklists(id) {
  if (process.env.VUE_APP_INTERCOM_APP_ID) {
    show();
    switch (id) {
      case 'who_sees_what':
        startTour(CHECKLISTS_WHO_SEES_WHAT_ID);
        break;
      case 'discover_core_capabilities':
        startTour(CHECKLISTS_DISCOVER_CORE_CAPABILITIES_ID);
        break;
      default:
        break;
    }
  }
}

export const getCurrentValidObject = () => (store.getters.objects.some((object) => object.attributes.type === 'StandardObject') ? store.getters.objects.find((object) => object.attributes.type === 'StandardObject') : store.getters.objects[0]);

export function showIntercom(source = 'manual') {
  if (process.env.VUE_APP_INTERCOM_APP_ID) {
    show();
    try {
      trackSecondaryEvent('intercom_interaction', {
        action: 'open',
        source,
      });
    } catch {
      // Silently handle analytics errors to not block Intercom functionality
    }
  }
}

export function trackIntercomEvent(eventName, metadata = null) {
  if (!process.env.VUE_APP_INTERCOM_APP_ID) return;
  trackEvent(eventName, metadata); // Intercom trackEvent, not RudderStack
}
